import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { ScrollProgress } from "@/components/common/ScrollProgress";
import { Marquee } from "@/components/common/Marquee";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { ProjectSpotlight } from "@/components/sections/ProjectSpotlight";
import { About } from "@/components/sections/About";
import { Services } from "@/components/sections/Services";
import { FeaturedProjects } from "@/components/sections/FeaturedProjects";
import { VideoSection } from "@/components/sections/VideoSection";
import { Gallery } from "@/components/sections/Gallery";
import { Capabilities } from "@/components/sections/Capabilities";
import { WhyDeuces } from "@/components/sections/WhyDeuces";
import { Manifesto } from "@/components/sections/Manifesto";
import { Reviews } from "@/components/sections/Reviews";
import { CtaBanner } from "@/components/sections/CtaBanner";
import { Warranty } from "@/components/sections/Warranty";
import { FAQ } from "@/components/sections/FAQ";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { FloatingActions } from "@/components/sections/FloatingActions";

const MARQUEE = [
  "MOBILE WELDING",
  "WHEEL REPAIR",
  "GATE REPAIR",
  "ALUMINUM TIG",
  "CUSTOM FABRICATION",
  "TRAILER REPAIR",
  "EMERGENCY WELDING",
];

export default function Home() {
  useSmoothScroll();

  return (
    <div className="bg-ink text-white overflow-x-hidden pb-14 lg:pb-0">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <ProjectSpotlight />
        <About />
        <div className="border-y border-white/5 bg-charcoal/40 py-6">
          <Marquee items={MARQUEE} />
        </div>
        <Services />
        <FeaturedProjects />
        <VideoSection />
        <Gallery />
        <Capabilities />
        <WhyDeuces />
        <Manifesto />
        <Reviews />
        <CtaBanner />
        <Warranty />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
